import { Auth0Provider } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import { AuthInit } from "./AuthInit";
import { SecureApp } from "./SecureApp";

export const Authentication: React.FC<any> = ({ children }) => {
  const navigate = useNavigate();

  const domain = appConfig.auth0.domain;
  const clientId = appConfig.auth0.clientId;
  const redirectUri = appConfig.auth0.redirectUri;
  const audience = appConfig.auth0.audience;

  const onRedirectCallback = appState => {
    navigate(appState?.returnTo || "login_complete");
  };

  if (!(domain && clientId && redirectUri && audience)) {
    return null;
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      cacheLocation="memory"
      authorizationParams={{
        audience: audience,
        redirect_uri: redirectUri
      }}
      onRedirectCallback={onRedirectCallback}
    >
      <SecureApp>
        <AuthInit>{children}</AuthInit>
      </SecureApp>
    </Auth0Provider>
  );
};
